import "@hotwired/turbo-rails";
import { application } from "./controllers/application";

import AutocompleteController from "./controllers/frontend/autocomplete_controller";
import DropzoneController from "./controllers/frontend/dropzone_controller";
import AutoclickController from "./controllers/frontend/autoclick_controller";
import RevealWithDisableInputsController from "./controllers/reveal_with_disable_inputs_controller";
import NestedFormController from "./controllers/nested_form_controller";
import Reveal from "@stimulus-components/reveal";
import CheckboxSelectAllController from "./controllers/frontend/checkbox_select_all_controller";
import SortableController from "./controllers/frontend/sortable_controller";
import GradeIrrelevantController from "./controllers/frontend/grade_irrelevant_controller";
import Dialog from "@stimulus-components/dialog";
import ConditionalRevealController from "./controllers/conditional_reveal_controller";
import CountdownController from "./controllers/frontend/countdown_controller";
import PrivacyOverlayController from "./controllers/frontend/privacy_overlay_controller";
import RevealWithTextToggleController from "./controllers/reveal-with-text-toggle";
import PrintController from "./controllers/print-controller";
import AccessibleAutocompleteController from "./controllers/accessible_autocomplete";
import MapController from "./controllers/frontend/map_controller";
import DownloadCheckedFormsController from "./controllers/frontend/download_checked_forms";
import SearchController from "./controllers/search_controller";

application.register("autocomplete", AutocompleteController);
application.register("dropzone", DropzoneController);
application.register("autoclick", AutoclickController);
application.register("reveal", Reveal);
application.register(
  "reveal-with-disable-inputs",
  RevealWithDisableInputsController
);
application.register("nested-form", NestedFormController);
application.register("checkbox-select-all", CheckboxSelectAllController);
application.register("sortable", SortableController);
application.register("grade-irrelevant", GradeIrrelevantController);
application.register("dialog", Dialog);
application.register("conditional-reveal", ConditionalRevealController);
application.register("countdown", CountdownController);
application.register("privacy-overlay", PrivacyOverlayController);
application.register("reveal-with-text-toggle", RevealWithTextToggleController);
application.register("print", PrintController);
application.register(
  "accessible-autocomplete",
  AccessibleAutocompleteController
);
application.register("map", MapController);
application.register("download-checked-forms", DownloadCheckedFormsController);
application.register("search", SearchController);
